import { render, staticRenderFns } from "./CCIItem.vue?vue&type=template&id=5f6b3636&"
import script from "./CCIItem.vue?vue&type=script&lang=js&"
export * from "./CCIItem.vue?vue&type=script&lang=js&"
import style0 from "./CCIItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports